export default "__VITE_ASSET__06d1fd73__"